import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import { getCanonicalURL, shareLink } from 'common/utils';

const ShareBar = ({ landingPage }) => {
  const pageUrl = getCanonicalURL(landingPage.seo_canonical_url || landingPage.url_stem);

  if (!landingPage.show_social_share) {
    return null;
  }

  return (
    <aside className="share-bar">
      { ["twitter", "facebook", "linkedin"].map(socialNet => (
      <a key={socialNet} className={socialNet} onClick={partial(
        shareLink, landingPage.social_posts[socialNet] || pageUrl, socialNet
      )}>
        <i className={`fa fa-${socialNet}`} />
      </a>
      )) }
    </aside>
  );
}

ShareBar.propTypes = {
  landingPage: PropTypes.object.isRequired
};

export default ShareBar;
